export default "__VITE_ASSET__CL37w5Sr__"